export default ({ COLORS }) => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  addGroupButton: {
    margin: '0 0 0 auto'
  },
  showingSelected: {
    display: 'flex',
    alignItems: 'center'
  },
  showAll: {
    color: COLORS.BLUE.NORMAL,
    cursor: 'pointer',
    fontWeight: 'bold',
    margin: '0 0 0 5px'
  }
})
